import { forwardRef, type ButtonHTMLAttributes } from "react";

import { cn } from "@/lib/utils";

export type ClientButtonVariant = "primary" | "secondary";

export type ClientButtonProps = {
  variant?: ClientButtonVariant;
} & ButtonHTMLAttributes<HTMLButtonElement>;

const variantStyles: Record<ClientButtonVariant, string> = {
  primary:
    "bg-[#38bdf8] text-[#0c1b2e] hover:bg-[#7dd3fc] active:bg-[#38bdf8]/90",
  secondary:
    "border border-[rgba(56,189,248,0.35)] bg-[rgba(11,22,40,0.42)] text-[rgba(255,255,255,0.50)] backdrop-blur-[8px] hover:border-[#38bdf8] hover:bg-[rgba(56,189,248,0.18)] hover:text-white active:bg-[rgba(11,22,40,0.55)]",
};

/**
 * TCI client action button (Figma 374:1559).
 * Desktop/tablet: fixed 225×46. Mobile: full-width, same height.
 */
export const ClientButton = forwardRef<HTMLButtonElement, ClientButtonProps>(
  function ClientButton(
    { variant = "primary", className, type = "button", ...props },
    ref,
  ) {
    return (
      <button
        ref={ref}
        type={type}
        className={cn(
          "inline-flex h-[46px] w-full items-center justify-center px-5 py-3 font-['Inter'] text-sm font-medium leading-5 tracking-[-0.35px] transition-colors",
          "sm:w-[225px] sm:min-w-[225px] sm:shrink-0",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-400 focus-visible:ring-offset-2 focus-visible:ring-offset-black",
          "disabled:pointer-events-none disabled:opacity-50",
          variantStyles[variant],
          className,
        )}
        {...props}
      />
    );
  },
);
